<div class="container-fluid h-100 pb-3">
  <div class="row">
    <div class="col">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <span class="title">{{ content.title
            }}</span>
          <span class="sub-title" *ngIf="content.subTitle">{{ content.subTitle }}</span>
        </div>
        <ng-container *ngIf="!content.moveControlsToNextLine">
          <div class="d-flex" *ngIf="content.globalsearch">
            <div class="search-container">
              <input type="text" placeholder="Search" [(ngModel)]="searchQuery" (input)="onSearchChange()" />
              <i class="fa fa-search search-icon"></i>
            </div>
          </div>
          <div class="d-flex" *ngIf="buttonArray?.length">
            <ng-container *ngFor="let redirectBtn of buttonArray">
              <button class="fb-dasboardhboard-table-top-button" (click)="redirect(redirectBtn.pageFormId)"> {{
                redirectBtn.name
                }} </button>
            </ng-container>
          </div>
          <div class="d-flex" *ngIf="filterArray?.length">
            <ng-container *ngFor="let filter of filterArray; let i = index">
              <ng-container *ngIf="filter.filterType === 'Outcome'">
                <p-dropdown appendTo="body" [options]="outcome" [(ngModel)]="selectedOutcome" optionLabel="key"
                  (ngModelChange)="getDetailsPostFilter()" optionValue="value"
                  styleClass="fb-dashboard-card-filter-dropdown outcome-filter"
                  [ngClass]="{'margin-left': i !== 0 && filterArray.length > 1}"></p-dropdown>
              </ng-container>
              <ng-container *ngIf="filter.filterType === 'Year'">
                <!-- pTooltip="{{selectedYear}}" tooltipPosition="left" -->
                <p-dropdown appendTo="body" [options]="years" [(ngModel)]="selectedYear" optionLabel="key"
                  (ngModelChange)="getDetailsPostFilter()" optionValue="value"
                  styleClass="fb-dashboard-card-filter-dropdown year-filter"
                  [ngClass]="{'margin-left': i !== 0 && filterArray.length > 1}"></p-dropdown>
              </ng-container>
              <ng-container *ngIf="filter.filterType === 'Month'">
                <!-- pTooltip="{{tooltipSelectedMonth}}" tooltipPosition="left"
                  (ngModelChange)="updateTooltipMonth(selectedMonth);getDetailsPostFilter();" -->
                <p-dropdown appendTo="body" [options]="months" [(ngModel)]="selectedMonth" optionLabel="key"
                  (ngModelChange)="getDetailsPostFilter();" optionValue="value"
                  styleClass="fb-dashboard-card-filter-dropdown month-filter"
                  [ngClass]="{'margin-left': i !== 0 && filterArray.length > 1}"></p-dropdown>
              </ng-container>
              <ng-container *ngIf="['referenceLibrary', 'APIValues'].includes(filter.filterType)">
                <ng-container *ngIf="!filter.multiSelect">
                  <!-- tooltipPosition="left"
                  pTooltip="{{filter.tooltipSelectedValue}}" (ngModelChange)="updateTooltipReferenceLibrary(filter);getDetailsPostFilter();" -->
                  <p-dropdown appendTo="body" [options]="filter.dropDownArray"
                    [(ngModel)]="filter.selectedReferenceValue" optionLabel="name"
                    (ngModelChange)="getDetailsPostFilter()" optionValue="value"
                    styleClass="fb-dashboard-card-filter-dropdown" [ngStyle]="{'width.px': filter.filterWidth}"
                    [filter]="filter.search" filterBy="name"
                    [ngClass]="{'margin-left': i !== 0 && filterArray.length > 1}"></p-dropdown>
                </ng-container>
                <ng-container *ngIf="filter.multiSelect">
                  <p-multiSelect appendTo="body" [options]="filter.dropDownArray"
                    [(ngModel)]="filter.selectedReferenceValue" optionLabel="name" optionValue="value"
                    (onChange)="getDetailsPostFilter()" styleClass="fb-dashboard-card-filter-dropdown"
                    [ngStyle]="{'width.px': filter.filterWidth}"
                    [ngClass]="{'margin-left': i !== 0 && filterArray.length > 1}">
                    <ng-template let-selectedItems pTemplate="selectedItems">
                      <span *ngIf="!selectedItems?.length">Select {{ filter.itemsLabel }}s</span>
                      <span
                        *ngIf="selectedItems?.length && filter?.dropDownArray?.length && selectedItems.length === filter.dropDownArray.length && selectedItems.length > 1">All
                        {{ filter.itemsLabel }}s selected</span>
                      <span
                        *ngIf="selectedItems?.length && filter?.dropDownArray?.length && selectedItems.length === filter.dropDownArray.length && selectedItems.length === 1">All
                        {{ filter.itemsLabel }} selected</span>
                      <span
                        *ngIf="selectedItems?.length && filter?.dropDownArray?.length && selectedItems.length !== filter.dropDownArray.length && selectedItems.length > 1">
                        {{ selectedItems.length }} {{ filter.itemsLabel }}s selected</span>
                      <span
                        *ngIf="selectedItems?.length && filter?.dropDownArray?.length && selectedItems.length !== filter.dropDownArray.length && selectedItems.length === 1">
                        {{ selectedItems.length }} {{ filter.itemsLabel }} selected</span>
                    </ng-template>
                  </p-multiSelect>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="content.moveControlsToNextLine">
    <div class="col" *ngIf="content.globalsearch">
      <div class="search-container next-line">
        <input type="text" placeholder="Search" [(ngModel)]="searchQuery" (input)="onSearchChange()" />
        <i class="fa fa-search search-icon"></i>
      </div>
    </div>
    <ng-template [ngIf]="buttonArray?.length">
      <div class="col" *ngFor="let redirectBtn of buttonArray">
        <button class="fb-dasboardhboard-table-top-button" (click)="redirect(redirectBtn.pageFormId)"> {{
          redirectBtn.name
          }} </button>
      </div>
    </ng-template>
    <ng-template [ngIf]="filterArray?.length">
      <div class="col" *ngFor="let filter of filterArray; let i = index">
        <ng-container *ngIf="filter.filterType === 'Outcome'">
          <p-dropdown appendTo="body" [options]="outcome" [(ngModel)]="selectedOutcome" optionLabel="key"
            (ngModelChange)="getDetailsPostFilter()" optionValue="value"
            styleClass="fb-dashboard-card-filter-dropdown w-100"></p-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.filterType === 'Year'">
          <!-- pTooltip="{{selectedYear}}" tooltipPosition="left" -->
          <p-dropdown appendTo="body" [options]="years" [(ngModel)]="selectedYear" optionLabel="key"
            (ngModelChange)="getDetailsPostFilter()" optionValue="value"
            styleClass="fb-dashboard-card-filter-dropdown w-100"></p-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.filterType === 'Month'">
          <!-- pTooltip="{{tooltipSelectedMonth}}" tooltipPosition="left"
                  (ngModelChange)="updateTooltipMonth(selectedMonth);getDetailsPostFilter();" -->
          <p-dropdown appendTo="body" [options]="months" [(ngModel)]="selectedMonth" optionLabel="key"
            (ngModelChange)="getDetailsPostFilter();" optionValue="value"
            styleClass="fb-dashboard-card-filter-dropdown w-100"></p-dropdown>
        </ng-container>
        <ng-container *ngIf="['referenceLibrary', 'APIValues'].includes(filter.filterType)">
          <ng-container *ngIf="!filter.multiSelect">
            <!-- tooltipPosition="left"
                  pTooltip="{{filter.tooltipSelectedValue}}" (ngModelChange)="updateTooltipReferenceLibrary(filter);getDetailsPostFilter();" -->
            <p-dropdown appendTo="body" [options]="filter.dropDownArray" [(ngModel)]="filter.selectedReferenceValue"
              optionLabel="name" (ngModelChange)="getDetailsPostFilter()" optionValue="value" [filter]="filter.search"
              filterBy="name" styleClass="fb-dashboard-card-filter-dropdown w-100"></p-dropdown>
          </ng-container>
          <ng-container *ngIf="filter.multiSelect">
            <p-multiSelect appendTo="body" [options]="filter.dropDownArray" [(ngModel)]="filter.selectedReferenceValue"
              optionLabel="name" optionValue="value" (onChange)="getDetailsPostFilter()"
              styleClass="fb-dashboard-card-filter-dropdown w-100">
              <ng-template let-selectedItems pTemplate="selectedItems">
                <span *ngIf="!selectedItems?.length">Select {{ filter.itemsLabel }}s</span>
                <span
                  *ngIf="selectedItems?.length && filter?.dropDownArray?.length && selectedItems.length === filter.dropDownArray.length && selectedItems.length > 1">All
                  {{ filter.itemsLabel }}s selected</span>
                <span
                  *ngIf="selectedItems?.length && filter?.dropDownArray?.length && selectedItems.length === filter.dropDownArray.length && selectedItems.length === 1">All
                  {{ filter.itemsLabel }} selected</span>
                <span
                  *ngIf="selectedItems?.length && filter?.dropDownArray?.length && selectedItems.length !== filter.dropDownArray.length && selectedItems.length > 1">
                  {{ selectedItems.length }} {{ filter.itemsLabel }}s selected</span>
                <span
                  *ngIf="selectedItems?.length && filter?.dropDownArray?.length && selectedItems.length !== filter.dropDownArray.length && selectedItems.length === 1">
                  {{ selectedItems.length }} {{ filter.itemsLabel }} selected</span>
              </ng-template>
            </p-multiSelect>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>
  </div>
  <div class="row" *ngIf="!content.moveControlsToNextLine">
    <div class="col-12">
      <p-divider styleClass="divider-m-5"></p-divider>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="container-fluid pb-3 container-content"
        [ngClass]="{'contains-sub-title': content.subTitle, 'no-redirect': !content.dashboardRedirectPageFormId}">
        <div class="row py-2">
          <div class="col-12"
            [ngStyle]="{ 'height': content?.minTableHeight ? content.minTableHeight + 'px' : 'auto' }">
            <p-table [value]="tableList" tableStyleClass="fb-table"
              [styleClass]="content.tableClass ? content.tableClass : ''" [scrollable]="isTableScrollable"
              [scrollHeight]="tableScrollableHeight + 'px'">
              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of columns" scope="col" [ngClass]="col.class">{{col.header}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData>
                <tr>
                  <td *ngFor="let col of columns" [ngClass]="getConditionalClass(rowData, col) || col.tdClass">
                    <ng-container *ngIf="col.type && col.type === 'action'">
                      <ng-container *ngIf="col.actionType && col.actionType === 'button'">
                        <button type="button" class="button-schedule"
                          (click)="onButtonActionClick(col, rowData)">{{col.buttonName}}</button>
                      </ng-container>
                    </ng-container>
                    <ng-container
                      *ngIf="col.field === 'resume' && rowData[col.field] && (contentInUse.title === 'Top 5 Recent Submissions' || contentInUse.title === 'Quick Interview Scheduling')">
                      <a (click)="openDoc(rowData[col.field])" class="pdf-link">
                        <!-- <i class="pi pi-file-pdf"></i> --> <img src="assets/Doc.svg" alt="PDF" class="pdf-icon">
                      </a>
                    </ng-container>
                    <ng-container *ngIf="col.field !== 'resume' && !!col.showInfoText">
                      <div class="col-wrapper">
                        <div class="col-content">{{rowData[col.field]}}</div>
                        <div class="col-info-text">
                          <span class="pi pi-ellipsis-v" *ngIf="rowData[col.infoTextProperty]"
                            pTooltip="{{ stripHtmlTags(rowData[col.infoTextProperty]) }}" tooltipEvent="focus"
                            tabindex="0"></span>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="col.field !== 'resume' && !col.showInfoText">
                      {{rowData[col.field]}}
                    </ng-container>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="columns?.length || 1" class="text-center">No records found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row"
    *ngIf="showMore && numberOfRowsLimitOnShowMore && onShowMoreCompleteTableList?.length > numberOfRowsLimitOnShowMore">
    <div class="col-12 text-center">
      <a class="link" (click)="onShowMore()">View {{isShowMore ? 'less' : 'all'}}</a>
    </div>
  </div>
  <div class="row" *ngIf="content.dashboardRedirectPageFormId && !showMore">
    <div class="col-12 text-center">
      <a class="link" (click)="redirect(content.dashboardRedirectPageFormId)">{{ content.footerLink }}</a>
    </div>
  </div>
</div>